import { yearDiff, removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

function getMessage(field, args) {
  if (args === void 0) args = []
  const minAge = args[1]
  const maxAge = args[2]
  let asOfNextBday = args[3]
  if (asOfNextBday === null || asOfNextBday === undefined) {
    asOfNextBday = false
  }
  if (asOfNextBday) {
    return `The ${field} must be between ${minAge} and ${maxAge} years old. (As of next birthday)`
  } else {
    return `The ${field} must be between ${minAge} and ${maxAge} years old.`
  }
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    let startDate = args[0]
    if (!startDate) {
      startDate = new Date()
    }
    const minAge = args[1]
    const maxAge = args[2]
    let asOfNextBday = args[3]
    if (asOfNextBday === null || asOfNextBday === undefined) {
      asOfNextBday = false
    }
    let age = yearDiff(startDate, value)
    if (asOfNextBday) {
      if (!isAfter(removeTime(value), removeTime(startDate))) {
        age++
      }
    }
    if (age < minAge || age > maxAge) {
      return false
    } else {
      return true
    }
  } else return true
}

export default {
  getMessage,
  validate
}
